/*
 * -----------------------------------------------------------------------
 *  <copyright file="cancel-button.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import Button from './button';

const CancelButton = (props: any) => <Button outlined text="cancel" {...props} />;

export default CancelButton;
